import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { toastr } from "react-redux-toastr"
import QRCode from "qrcode.react"

import {
  Breadcrumb,
  BreadcrumbItem,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Col,
  Container,
  Row
} from "reactstrap";

import Api from "../../api"
import Header from "../../components/Header";
import HeaderTitle from "../../components/HeaderTitle";

import AssetForm from "../../components/AssetForm";
import AssetLogTable from "../../components/AssetLogTable"


const LogView = ({ asset }) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle tag="h5">Change Log</CardTitle>
      </CardHeader>
      <CardBody>
        <AssetLogTable logs={asset.logs} />
      </CardBody>
    </Card >
  )
}

const QrView = ({ asset }) => {
  const QrCode = asset.tag_id ? <QRCode size={300} value={`${asset.tag_id}`} /> : null
  return (
    <Card>
      <CardHeader>
        <CardTitle tag="h5">QR Code</CardTitle>
      </CardHeader>
      <CardBody className='qr-view'>
        {QrCode}
        <h6 className="card-subtitle text-muted">
          Asset Tag ID
      </h6>
        <h2>{asset.tag_id}</h2>
      </CardBody>
    </Card >
  )
};

const AssetEdit = () => {
  let { id } = useParams();

  const [asset, setAsset] = useState({
    id: null,
    tag_id: '',
    location: '',
    points_to: '',
    radio_type: '',
    ip_address: '',
    logs: [],
  });

  const handleTypeChange = (radioType) => {
    setAsset({
      ...asset,
      radio_type: radioType.value
    })
  }

  const handleSelectChange = (field, value) => {
    setAsset({
      ...asset,
      [field]: value.value
    })
  }

  const handleChange = event => {
    setAsset({
      ...asset,
      [event.target.name]: event.target.value,
    })
  };

  const loadAsset = id => {
    Api.get(`/main/assets/${id}/`).then((res) => {
      setAsset(res.data)
    }).catch((err) => {
      toastr.error(`${err}`)
    })
  }

  const handleSubmit = () => {
    Api.put(`/main/assets/${asset.id}/`, asset).then((res) => {
      toastr.success(`Updated tag ${asset.tag_id}`)
      loadAsset(id)
    }).catch((err) => {
      toastr.error(`${err}`)
    })
  }



  useEffect(() => {
    loadAsset(id)
  }, [id]);

  return (
    <Container fluid>
      <Header>
        <HeaderTitle>Editing tag ID {asset.tag_id}</HeaderTitle>

        <Breadcrumb>
          <BreadcrumbItem>
            <Link to="/assets">Assets</Link>
          </BreadcrumbItem>
          <BreadcrumbItem active>Edit</BreadcrumbItem>
        </Breadcrumb>
      </Header>

      <Row>
        <Col lg="8">
          <AssetForm
            asset={asset}
            onChange={handleChange}
            onTypeChange={handleTypeChange}
            handleSelectChange={handleSelectChange}
            onSubmit={handleSubmit}
          />
        </Col>
        <Col lg="4" >
          <QrView asset={asset} />
        </Col>
        <Col lg="12" >
          <LogView asset={asset} />
        </Col>
      </Row>
    </Container >
  )
}

export default AssetEdit